import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center p-5">
      <div className="bg-white rounded-xl shadow-2xl p-10 w-full max-w-[500px] text-center">
        <div className="mb-8">
          <div className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-indigo-500 to-purple-600 mb-4">
            404
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            ページが見つかりません
          </h1>
          <p className="text-gray-600 leading-relaxed">
            お探しのページは存在しないか、移動または削除された可能性があります。
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleGoHome}
            className="w-full py-3 px-6 bg-indigo-600 text-white border-none rounded-md text-base font-medium cursor-pointer transition-colors hover:bg-indigo-700"
          >
            {isAuthenticated ? "ダッシュボードに戻る" : "ログインページへ"}
          </button>
          <button
            onClick={handleGoBack}
            className="w-full py-3 px-6 bg-white text-gray-700 border-2 border-gray-300 rounded-md text-base font-medium cursor-pointer transition-colors hover:bg-gray-50"
          >
            前のページに戻る
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            問題が解決しない場合は、お手数ですがお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
